import React from 'react'
import { shallow } from 'enzyme'
import { OrderTranscriptsModal } from '../../modals/OrderTranscriptsModal'
import * as dependency from '../../helpers/EsignUtil'
import getOpenTranscriptsModalDocProps from './data/OpenTranscriptsModalDocPropsTestData'
import getOpenTranscriptsModalProps from "./data/OpenTranscriptsModalPropsTestData"

describe('OpenTranscriptsModal', () => {
    const docProps = getOpenTranscriptsModalDocProps();
    let wrapper, instance, props
    beforeEach(() => {
        props = getOpenTranscriptsModalProps(docProps);
        wrapper = shallow(<OrderTranscriptsModal {...props} />);
        instance = wrapper.instance();

    })
    it('must render the wrapper', () => {
        expect(wrapper).not.toBeNull();
    })
    it('should have a close button', () => {
           expect(wrapper.find('OrderTranscriptsModal__Close').length).toBe(1);
    })
    it('should have a header', () => {
        expect(wrapper.find('OrderTranscriptsModal__Header').length).toBe(1);
    })
    it('should have a name ', () => {
        console.log(wrapper.debug());
        expect(wrapper.find('OrderTranscriptsModal__Name').length).toBe(1);
        expect(wrapper.find('OrderTranscriptsModal__Name').prop('children')).toContain('Personal Tax Transcripts');
    })
    it('should have a title in the name field', () => {
        expect(wrapper.find('OrderTranscriptsModal__Name').prop('children')).toContain('Personal Tax Transcripts');
    })
    it('should contain a tax year selection', () => {
        expect(wrapper.find('#tax_year_select').length).toBe(1);
    })
    it('should contain a tax form selection', () => {
        expect(wrapper.find('#tax_form_select').length).toBe(1);
    })
    it('should contain a tax form options', () => {
        expect(wrapper.find('#tax_form_select').find('option').length).toBe(4);
    })
    it('should contain a tax form container', () => {
        expect(wrapper.find('OrderTranscriptsModal__TaxFormContainer').length).toBe(1);
    })
    describe('footer', () => {
        it('should contain a footer', () => {
            expect(wrapper.find('OrderTranscriptsModal__Footer').length).toBe(1);
        })
        it('should contain a footer with a cancel button', () => {
            expect(wrapper.find('OrderTranscriptsModal__Footer').find('Button').length).toBe(1);
        })
        it('should contain a footer with a submit button', () => {
            expect(wrapper.find('OrderTranscriptsModal__Footer').find('OrderTranscriptsModal__SubmitButton').length).toBe(1);
        })
        it('should contain a footer with a submit button with a prompt', () => {
            expect(wrapper.find('OrderTranscriptsModal__Footer')
                .find('OrderTranscriptsModal__SubmitButton').prop('children')).toContain('Electronically Sign Order');
        })
    });
    describe('test esigning', () => {
        it('should start esign process', () => {
            dependency.openEsignModal = jest.fn();
            props.updateTaxReturns.mockReturnValue("DocID123");
            props.getHelloSignUrl.mockReturnValue("http://www.google.com");
            instance.onSubmit().then(data => {
                expect(dependency.openEsignModal.mock.calls.length).toBe(1);
                expect(dependency.openEsignModal.mock.calls[0][0]).toStrictEqual({ clientId: '123456789', testMode: true });
                expect(dependency.openEsignModal.mock.calls[0][1]).toBe('sign')
                expect(dependency.openEsignModal.mock.calls[0][2]).toStrictEqual(instance.messageListener)
                expect(dependency.openEsignModal.mock.calls[0][3]).toBe('http://www.google.com')
            });
        });
    });

});
